"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoLoaded = exports.LoadingScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const rxjs_1 = require("../../../hooks/rxjs");
function LoadingScreen({ videoController }) {
    const videoLoadedYn = (0, exports.useVideoLoaded)(videoController);
    return (0, react_1.useMemo)(() => videoLoadedYn ? null : ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "40px", color: "white" }) })), [videoLoadedYn]);
}
exports.LoadingScreen = LoadingScreen;
const Container = ui_react_1.styled.span `
    z-index: 3;
    position: absolute;
`;
// export for testing
const useVideoLoaded = (videoController) => {
    // a user will be connected before their video starts.  So, when video is enabled,
    //   wait until it has started before removing the spinner.  When video is not enabled
    //   (the user's camera is off), remove the spinner when the user is connected, since
    //   disabled video will never start.
    const [videoStarted] = (0, rxjs_1.useObservable)(videoController.started);
    const [videoConnected] = (0, rxjs_1.useObservable)(videoController.connected);
    const [videoEnabled] = (0, rxjs_1.useObservable)(videoController.enabled);
    return !!videoStarted || (!!videoConnected && !videoEnabled);
};
exports.useVideoLoaded = useVideoLoaded;
//# sourceMappingURL=loading_screen.js.map